/* STEP 2 · A9 — on a TB-only engagement every Analytics card / chart that reads journal lines says "Not applicable on a
   TB-only engagement" (the existing text, sbe.tbOnly.title) — never a 0, an empty chart or a "Test these now" button.
   Which parts: the payload's ``not_applicable_parts`` ({revenue: [...], expenses: [...], balance_sheet: [...]}, written by
   backend analytics.tb_only_view with ``tb_only: true``). ``partNa(data, "revenue", "monthly")`` answers for one part;
   <TbOnlyPart na={…} testid=…>children</TbOnlyPart> shows the text in place of the children. */
import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { isTbOnly } from "@/components/TbOnlyNotice";

export function partNa(data, section, key) {
  if (!isTbOnly(data)) return false;
  const parts = (data && data.not_applicable_parts) || {};
  return Array.isArray(parts[section]) && parts[section].includes(key);
}

export default function TbOnlyPart({ na, testid, children }) {
  const { t } = useI18n();
  if (!na) return <>{children}</>;
  return (
    <div className="mt-2 text-sm text-muted-foreground" role="status" data-testid={testid}>
      {t("sbe.tbOnly.title")}
    </div>
  );
}
